var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow Right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M9.33711 0.130737C9.13317 -0.0554432 8.81692 -0.0410458 8.63074 0.162894C8.44456 0.366834 8.45895 0.683089 8.66289 0.869269L14.8307 6.5H1C0.723858 6.5 0.5 6.72386 0.5 7C0.5 7.27614 0.723858 7.5 1 7.5H14.8279L8.66289 13.1281C8.45895 13.3143 8.44456 13.6305 8.63074 13.8345C8.81692 14.0384 9.13317 14.0528 9.33711 13.8666L16.2535 7.55258C16.3934 7.42482 16.4732 7.25728 16.493 7.08414C16.4976 7.05678 16.5 7.02867 16.5 7C16.5 6.97313 16.4979 6.94675 16.4938 6.92103C16.4756 6.74512 16.3955 6.57446 16.2535 6.44478L9.33711 0.130737Z",
    fill: "#009CDB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/Arrow Right.c21fe60efc3a8a48a4f2379cb57a5e22.svg";
export { ForwardRef as ReactComponent };